import request from '@/utils/request'

export function addAuthorizeApi(data) {
  return request({
    url: '/sealInfo/addAuthorize',
    method: 'post',
    data
  })
}

export function showAuthInfoApi(data) {
  return request({
    url: '/sealInfo/viewMessage?messageId='+data.messageId+'&nocache='+new Date().getTime(),
    method: 'get'
  })
}

export function agreeAuthorizeApi(data) {
  return request({
    url: '/sealInfo/agreeMessage',
    method: 'post',
    data
  })
}

export function unAgreeAuthorizeApi(data) {
  return request({
    url: '/sealInfo/denialMessage',
    method: 'post',
    data
  })
}

export function backSealApi(data) {
  return request({
    url: '/sealInfo/deleteAuthorize',
    method: 'post',
    data
  })
}
